<template>
	<div class="super-container">
		<div class="right-top-bar">
			<SidebarMicro class="sidebar-micro" :items="sidebarItems" :base-path="basePath"/>
		</div>
		<div class="content">
			<router-view/>
		</div>
	</div>
</template>

<script>
import SidebarMicro from "@/console-new/components/shared/SidebarMicro.vue";
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import {useSuperStore, useUserStore} from "@/user/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const superStore = useSuperStore();
		const svgStore = useSvgStore();
		const userStore = useUserStore();
		return {getString: languageStore.getString, userStore, superStore, getIcon: svgStore.get};
	},
	name: "SuperContainer",
	components: {SidebarMicro},
	data() {
		return {
			basePath: "/super"
		};
	},
	computed: {
		sidebarItems() {
			return [
				{name: this.getString('administration'), icon: 'iconBusinessConsole', path: '/business'},
				{name: this.getString('invoices'), icon: 'iconInvoice', path: '/invoices', shown: this.superStore.isUltra || this.superStore.isMega},
				{name: this.getString('support'), icon: 'iconChatBot', path: '/chats'},
				{name: this.getString('servers'), icon: 'iconWebsite', path: '/servers', shown: this.superStore.isUltra || this.superStore.isMega}
			];
		}
	},
	mounted() {
		if (this.$route.path === '/super') {
			this.$router.push('/super/business');
		}
		// Initialize super store data if not already loaded
		if (this.superStore.businesses === null) {
			this.superStore.fetchBusinesses();
		}
	}
};
</script>

<style lang="scss" scoped>
.super-container {
	display: flex;
	flex-direction: row;
	height: 100%;

	.right-top-bar {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		width: 250px;
		height: 100%;
		box-shadow: 0 1px 3px var(--color-alpha-3);

		.sidebar-micro {
			overflow-y: auto;
			border-top: 1px solid var(--color-alpha-3);
			height: 100%;
		}
	}

	.content {
		width: calc(100% - 250px);
		padding: var(--main-padding);
		overflow-y: auto;
	}

	@media (max-width: 920px) {
		.right-top-bar {
			display: none;
		}
		.content {
			width: 100%;
		}
	}
}
</style>
